import Vue from 'vue'

import Boxwrap from '@/components/layout/boxwrap/Boxwrap.vue'
import BoxwrapHeader from '@/components/layout/boxwrap/BoxwrapHeader'
import BoxwrapHeaderItems from '@/components/layout/boxwrap/BoxwrapHeaderItems'
import BoxwrapToolbar from '@/components/layout/boxwrap/BoxwrapToolbar'
import BoxwrapToolbarItem from '@/components/layout/boxwrap/BoxwrapToolbarItem'
import BoxwrapContents from '@/components/layout/boxwrap/BoxwrapContents'
import BoxwrapItems from '@/components/layout/boxwrap/BoxwrapItems'

Vue.component(Boxwrap.name, Boxwrap)
Vue.component(BoxwrapHeader.name, BoxwrapHeader)
Vue.component(BoxwrapHeaderItems.name, BoxwrapHeaderItems)
Vue.component(BoxwrapToolbar.name, BoxwrapToolbar)
Vue.component(BoxwrapToolbarItem.name, BoxwrapToolbarItem)
Vue.component(BoxwrapContents.name, BoxwrapContents)
Vue.component(BoxwrapItems.name, BoxwrapItems)
